<template>
  <div class="md-layout download-link md-alignment-top-left">
    <a :class="linkClass"
    class="file-link md-layout-item"
    @click="linkHandler"
    >
      <md-icon :class="iconInfo.class"> {{iconInfo.icon}} </md-icon>
      {{downloadLabel}}
      <md-tooltip md-direction="top" class="file-tooltip"
      v-if="tooltip">
        {{tooltip}}
      </md-tooltip>
    </a>
    <md-button class="md-danger md-just-icon md-round md-simple delete-archive-button md-layout-item"
    v-if="showDeleteButton" @click="deleteFile"> 
      <md-icon> close </md-icon>
    </md-button>
  </div>
</template>

<script>

import {downloadFile, fileIcon} from '@/utils'

const DEFAULT_ICON_INFO = {
  type: 'md-icon',
  icon: 'file_copy',
}

const DEFAULT_DOWNLOAD_LABEL = 'Descargar'

const baseName = function(str) {
  var base = new String(str).substring(str.lastIndexOf('/') + 1)

  if(base.lastIndexOf(".") != -1) {
    base = base.substring(0, base.lastIndexOf("."))
  }

  return base
}

const DO_NOTHING = () => {
}
 
export default {

  name: 'DownloadFileLink',

  props: {
  	label: {
  		type: String,
  		default: null,
  	},
    showFileName: {
      type: Boolean,
      default: false,
    },
  	file: {
  		type: String,
  		default: "",
  	},
  	name: {
  		type: String,
  		default: "download",
  	},
  	linkClass: {
  		type: [Array, String, Object],
  		default: "",
  	},
  	tooltip: {
  		type: String,
  		default: "",
  	},
    showDeleteButton: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    iconClass: {
      type: String,
      default: "",
    },
    notClickable: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    iconInfo () {
      let info

      if (this.icon) {
        info = {
          icon: this.icon,
          type: this.iconClass,
        }
      } else {
        info = fileIcon(this.file) || DEFAULT_ICON_INFO
      }

      if (info.type === 'fontawesome') {
        return {
          class: info.icon,
          icon: "",
        }
      } else {
        info = {
          icon: info.icon,
        }
      }

      return info
    },
    downloadLabel () {
      const label = this.label

      if (label) {
        return label
      } else if (this.showFileName) {
        return this.fileName
      } else {
        return DEFAULT_DOWNLOAD_LABEL
      }
    },
    fileName () {
      const file = this.file
      const base = baseName(file)
      const dots = base.length > 8 ? '...' : ''
      return `${base.substring(0, 8)}${dots}`
    },
    linkHandler () {
      return this.notClickable ? DO_NOTHING : this.download
    },
  },

  methods: {
    download() {
    	const url = this.file
    	const name = this.name
      const ext = url.split('.').slice(-1)[0]
      downloadFile(url, `${name}.${ext}`)
    },
    deleteFile() {
      this.$emit('delete', this.file)
    }
  },

  data () {
    return {
      iconInfoClass: null,
    }
  }
}
</script>

<style lang="css" scoped>
.download-link {
  position: relative;
  cursor: pointer;
}
.md-button.delete-archive-button {
  position: absolute;
  left: 100%;
  top: -45%;
}

.file-tooltip { font-size: 17px !important }
</style>


// WEBPACK FOOTER //
// src/components/DownloadFileLink.vue